import React, { PropsWithChildren } from "react";
import { MarkdownRenderer } from "../MarkdownRenderer";
import { Options } from "react-markdown";

type TaskContentProps = PropsWithChildren<
  { preserveSpaces?: boolean } & Omit<Options, "children">
>;

export const TaskContent = ({
  children,
  preserveSpaces,
  ...props
}: TaskContentProps) => {
  return typeof children === "string" ? (
    <MarkdownRenderer disallowedElements={["p"]} {...props}>
      {preserveSpaces ? children.replace(/(^\s)|(\s$)/g, "&nbsp;") : children}
    </MarkdownRenderer>
  ) : (
    <>{children}</>
  );
};
